// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { format } from 'date-fns';
// import { saveAs } from 'file-saver';
// import './TrialBalance.css'; // Assuming you have a CSS file for styling
// import AccountUploadForm from '../account/transactions/AccountUploadForm';


// const TrialBalance = () => {
//     const [data, setData] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [filters, setFilters] = useState({
//         start_date: null,
//         end_date: null
//     });
//     const [showUploadForm, setShowUploadForm] = useState(false);
//     const [refreshTrigger, setRefreshTrigger] = useState(0);
//     const API_BASE_URL = process.env.REACT_APP_WEBZASH_URL || 'http://localhost/webzash-integration';
//     const API_KEY = process.env.REACT_APP_API_KEY || 'your_api_key_here';
//     const [showForm, setShowForm] = useState(false);


//     useEffect(() => {
//         const fetchData = async () => {
//             setLoading(true);
//             setError(null);

//             try {
//                 const params = new URLSearchParams();
//                 if (filters.start_date) params.append('start_date', filters.start_date);
//                 if (filters.end_date) params.append('end_date', filters.end_date);

//                 const response = await axios.get(
//                     `${API_BASE_URL}/api/reports/trialbalance`,
//                     {
//                         headers: {
//                             'x-api-key': API_KEY,
//                             'Accept': 'application/json',
//                         },
//                         params
//                     }
//                 );

//                 setData(response.data);
//             } catch (err) {
//                 setError(err.response?.data?.message || 'Failed to fetch trial balance data');
//                 console.error('API Error:', err);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchData();
//     }, [filters, API_BASE_URL, API_KEY]);

//     const handleSubmit = (e) => {
//         e.preventDefault();
//     };

//     const handleClear = () => {
//         setFilters({
//             start_date: null,
//             end_date: null
//         });
//     };

//     const handleExport = async (formatType) => {
//         try {
//             const params = new URLSearchParams();
//             if (filters.start_date) params.append('start_date', filters.start_date);
//             if (filters.end_date) params.append('end_date', filters.end_date);
//             params.append('format', formatType);

//             const response = await axios.get(
//                 `${API_BASE_URL}/api/reports/trialbalance`,
//                 {
//                     headers: {
//                         'x-api-key': API_KEY,
//                         'Accept': '*/*',
//                     },
//                     params,
//                     responseType: 'blob'
//                 }
//             );

//             const extension = formatType === 'csv' ? 'csv' : 'xls';
//             saveAs(new Blob([response.data]), `trial_balance.${extension}`);
//         } catch (err) {
//             setError(`Failed to export ${formatType.toUpperCase()}`);
//             console.error('Export Error:', err);
//         }
//     };

//     const printReport = () => {
//         window.open(
//             `${API_BASE_URL}/api/reports/trialbalance?format=print${filters.start_date ? `&start_date=${filters.start_date}` : ''}${filters.end_date ? `&end_date=${filters.end_date}` : ''}`,
//             '_blank'
//         );
//     };
//     const handleUploadSuccess = () => {
//         setShowUploadForm(false);
//         // Refresh the trial balance data
//         setRefreshTrigger(prev => prev + 1);
//     };
//     const formatAmount = (amount) => {
//         return new Intl.NumberFormat('en-AE', {
//             minimumFractionDigits: 2,
//             maximumFractionDigits: 2
//         }).format(amount);
//     };

//     const renderAccount = (account, level = 0) => {
//         const hasChildren = account.children && account.children.length > 0;
//         const isGroup = hasChildren;

//         // Format amount with DR/CR prefix
//         const formatAmountWithDC = (amount, dc) => {
//             if (parseFloat(amount) === 0 || amount === "0.00") return '-';
//             const formatted = new Intl.NumberFormat('en-AE', {
//                 minimumFractionDigits: 2,
//                 maximumFractionDigits: 2
//             }).format(Math.abs(parseFloat(amount)));

//             return dc === 'D' ? `Dr ${formatted}` : `Cr ${formatted}`;
//         };

//         // Format regular amount without DR/CR
//         const formatAmount = (amount) => {
//             if (parseFloat(amount) === 0 || amount === "0.00") return '-';
//             return new Intl.NumberFormat('en-AE', {
//                 minimumFractionDigits: 2,
//                 maximumFractionDigits: 2
//             }).format(parseFloat(amount));
//         };

//         // Format opening and closing balances with DR/CR
//         const openingBalance = parseFloat(account.op_total) > 0 ?
//             formatAmountWithDC(account.op_total, account.op_total_dc) : '-';

//         const closingBalance = parseFloat(account.cl_total) > 0 ?
//             formatAmountWithDC(account.cl_total, account.cl_total_dc) : '-';

//         // Skip rendering the "None" or null-root row itself, but render its children
//         const shouldSkipRow = account.name === 'None' && account.id === null;

//         return (
//             <React.Fragment key={`${account.id || 'root'}-${level}`}>
//                 {!shouldSkipRow && (
//                     <tr className={isGroup ? 'group-row' : 'ledger-row'}>
//                         <td style={{ paddingLeft: `${level * 16}px` }}>
//                             {isGroup ? (
//                                 <span className="account-group">{account.name}</span>
//                             ) : (
//                                 <span className="account-name">{account.name}</span>
//                             )}
//                         </td>
//                         <td className="amount">{openingBalance}</td>
//                         <td className="amount">
//                             {parseFloat(account.dr_total) > 0 ? `Dr ${formatAmount(account.dr_total)}` : '-'}
//                         </td>
//                         <td className="amount">
//                             {parseFloat(account.cr_total) > 0 ? `Cr ${formatAmount(account.cr_total)}` : '-'}
//                         </td>
//                         <td className="amount">{closingBalance}</td>
//                     </tr>
//                 )}
//                 {hasChildren && account.children.map(child => renderAccount(child, shouldSkipRow ? level : level + 1))}
//             </React.Fragment>
//         );
//     };
//     return (
//         <div className="main-content">
//             <div className="page-content">
//                 <div className="container-fluid">
//                     <div className="row">
//                         <div className="col-12">
//                             <div className="page-title-box d-sm-flex align-items-center justify-content-between">
//                                 <h4 className="mb-sm-0 font-size-18">Financial Reports</h4>
//                             </div>
//                         </div>
//                     </div>

//                     <div className="trial-balance-container">
//                         {/* Header Section */}
//                         <div className="report-header">
//                             <div className="header-title">
//                                 <h1>Trial Balance Report</h1>
//                                 <p>View and analyze your account balances</p>
//                             </div>
//                             <div className="header-actions">
//                                 <button className="export-btn"
//                                  onClick={() => setShowForm(true)}>
//                                     ➕ Add
//                                 </button>
//                                 <button
//                                     onClick={() => handleExport('csv')}
//                                     className="export-btn"
//                                     disabled={loading || !data}
//                                 >
//                                     <span className="icon">📊</span> CSV
//                                 </button>
//                                 <button
//                                     onClick={() => handleExport('xls')}
//                                     className="export-btn"
//                                     disabled={loading || !data}
//                                 >
//                                     <span className="icon">📈</span> Excel
//                                 </button>
//                                 {/* <button
//                         onClick={printReport}
//                         className="export-btn"
//                         disabled={loading || !data}
//                     >
//                         <span className="icon">🖨️</span> Print
//                     </button> */}
//                             </div>
//                         </div>

//                         {/* Filter Section */}
//                         <div className="filter-section">
//                             <h2>Filters</h2>
//                             <form onSubmit={handleSubmit}>
//                                 <div className="filter-grid">
//                                     <div className="filter-group">
//                                         <label htmlFor="start_date">From Date</label>
//                                         <input
//                                             type="date"
//                                             id="start_date"
//                                             value={filters.start_date || ''}
//                                             onChange={(e) => setFilters({ ...filters, start_date: e.target.value })}
//                                         />
//                                     </div>

//                                     <div className="filter-group">
//                                         <label htmlFor="end_date">To Date</label>
//                                         <input
//                                             type="date"
//                                             id="end_date"
//                                             value={filters.end_date || ''}
//                                             onChange={(e) => setFilters({ ...filters, end_date: e.target.value })}
//                                         />
//                                     </div>

//                                     <div className="filter-actions">
//                                         <button
//                                             type="submit"
//                                             className="primary-btn"
//                                             disabled={loading}
//                                         >
//                                             {loading ? (
//                                                 <>
//                                                     <span className="spinner"></span>
//                                                     Processing...
//                                                 </>
//                                             ) : 'Apply Filters'}
//                                         </button>
//                                         <button
//                                             type="button"
//                                             className="secondary-btn"
//                                             onClick={handleClear}
//                                             disabled={loading}
//                                         >
//                                             Clear
//                                         </button>
//                                     </div>
//                                 </div>
//                             </form>
//                         </div>

//                         {/* Error Message */}
//                         {error && (
//                             <div className="error-message">
//                                 <span className="error-icon">⚠️</span>
//                                 <span>{error}</span>
//                                 <button onClick={() => setError(null)} className="error-close">
//                                     ×
//                                 </button>
//                             </div>
//                         )}

//                         {/* Loading State */}
//                         {loading && !data && (
//                             <div className="loading-state">
//                                 <div className="spinner"></div>
//                                 <p>Loading trial balance data...</p>
//                             </div>
//                         )}

//                         {/* Data Display */}
//                         {!loading && data && (
//                             <div className="report-content">
//                                 <div className="report-info">
//                                     <h3>
//                                         {filters.start_date || filters.end_date
//                                             ? `Period: ${filters.start_date ? format(new Date(filters.start_date), 'dd MMM yyyy') : 'Beginning'} to ${filters.end_date ? format(new Date(filters.end_date), 'dd MMM yyyy') : 'Now'}`
//                                             : 'All Accounts'}
//                                     </h3>
//                                     <span className="generated-on">
//                                         Generated on: {format(new Date(), 'dd MMM yyyy, hh:mm a')}
//                                     </span>
//                                 </div>

//                                 <div className="table-container">
//                                     <table className="trial-balance-table">
//                                         <thead>
//                                             <tr>
//                                                 <th>Account Name</th>
//                                                 <th>Opening Balance</th>
//                                                 <th>Debit Total</th>
//                                                 <th>Credit Total</th>
//                                                 <th>Closing Balance</th>
//                                             </tr>
//                                         </thead>

//                                         <tbody>
//                                             {data.accountlist?.map(account => renderAccount(account))}

//                                             {data.totals && (
//                                                 <tr className="total-row">
//                                                     <td><strong>Total</strong></td>
//                                                     <td className="amount"><strong>-</strong></td>
//                                                     <td className="amount"><strong>Dr {formatAmount(data.totals.debit_total)}</strong></td>
//                                                     <td className="amount"><strong>Cr {formatAmount(data.totals.credit_total)}</strong></td>
//                                                     <td className="amount"><strong>-</strong></td>
//                                                 </tr>
//                                             )}
//                                         </tbody>
//                                     </table>
//                                 </div>

//                                 {data.totals?.balanced !== undefined && (
//                                     <div className={`balance-status ${data.totals.balanced ? 'balanced' : 'unbalanced'}`}>
//                                         {data.totals.balanced ? '✓' : '⚠'}
//                                         <strong>
//                                             {data.totals.balanced
//                                                 ? 'Trial Balance is balanced'
//                                                 : 'Trial Balance is not balanced'}
//                                         </strong>
//                                     </div>
//                                 )}
//                             </div>
//                         )}
//                      <AccountUploadForm
//     show={showForm}
//     onClose={() => setShowForm(false)}
//     onSuccess={() => {
//         setShowForm(false);
//         setRefreshTrigger(prev => prev + 1);
//     }}
// />

//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };



// export default TrialBalance;


import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { format } from 'date-fns';
import { saveAs } from 'file-saver';
import './TrialBalance.css';
import AccountUploadForm from '../account/transactions/AccountUploadForm';
import LedgerDetailsOffcanvas from './LedgerDetailsOffcanvas';
import "react-datepicker/dist/react-datepicker.css";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import { getAdjustedStartDate, getAdjustedEndDate } from '../../utils/dateHelper';

const TrialBalance = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [filters, setFilters] = useState({
        start_date: null,
        end_date: null
    });
    const [dateRangeType, setDateRangeType] = useState('custom');
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const API_BASE_URL = process.env.REACT_APP_WEBZASH_URL || 'http://localhost/webzash-integration';
    const API_KEY = process.env.REACT_APP_API_KEY || 'your_api_key_here';
    const [showForm, setShowForm] = useState(false);
    const [expandedGroups, setExpandedGroups] = useState(new Set()); // Use Set for simple ID tracking
    const [selectedLedger, setSelectedLedger] = useState(null);
    const [showOffcanvas, setShowOffcanvas] = useState(false);

    // Initialize expanded state for all groups
    useEffect(() => {
        if (data && data.accountlist) {
            // Initially collapse all groups
            setExpandedGroups(new Set());
        }
    }, [data]);

    // Get all group IDs from the data
    const getAllGroupIds = () => {
        if (!data || !data.accountlist) return new Set();

        const groupIds = new Set();

        const findGroups = (accounts) => {
            accounts.forEach(account => {
                if (account.children && account.children.length > 0) {
                    groupIds.add(account.id);
                    if (account.children) {
                        findGroups(account.children);
                    }
                }
            });
        };

        findGroups(data.accountlist);
        return groupIds;
    };

    const toggleGroup = (groupId) => {
        setExpandedGroups(prev => {
            const newSet = new Set(prev);
            if (newSet.has(groupId)) {
                newSet.delete(groupId);
            } else {
                newSet.add(groupId);
            }
            return newSet;
        });
    };

    const handleLedgerClick = (item, parentName = '') => {
        const isGroup = !!(item.children && item.children.length > 0);
        setSelectedLedger({ ...item, group_name: parentName, is_group: isGroup });
        setShowOffcanvas(true);
    };

    const expandAllGroups = () => {
        const allGroupIds = getAllGroupIds();
        setExpandedGroups(allGroupIds);
    };

    const collapseAllGroups = () => {
        setExpandedGroups(new Set());
    };

    const isGroupExpanded = (groupId) => {
        return expandedGroups.has(groupId);
    };

    // Debug function
    const debugState = () => {
        console.log('Expanded Group IDs:', Array.from(expandedGroups));
        console.log('All Group IDs:', Array.from(getAllGroupIds()));
    };

    //    const handleSubmit = (e) => {
    //     e.preventDefault();
    //     setRefreshTrigger(prev => prev + 1);
    // };
    const handleSubmit = (e) => {
        e.preventDefault();
        fetchData(); // ✅ MANUAL ONLY
    };


    const handleClear = () => {
        const cleared = { start_date: null, end_date: null };
        setFilters(cleared);
        fetchData(cleared); // reload ALL data
    };

    const handleExport = async (formatType) => {
        try {
            const params = new URLSearchParams();
            if (filters.start_date) params.append('start_date', filters.start_date);
            if (filters.end_date) params.append('end_date', filters.end_date);
            params.append('format', formatType);

            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(
                `${backendUrl}/api/trial-balance`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Tenant-Origin': origin,
                        'Accept': '*/*',
                    },
                    params,
                    responseType: 'blob',
                    skipLoader: true
                }
            );

            const extension = formatType === 'csv' ? 'csv' : 'xls';
            saveAs(new Blob([response.data]), `trial_balance.${extension}`);
        } catch (err) {
            setError(`Failed to export ${formatType.toUpperCase()}`);
            console.error('Export Error:', err);
        }
    };

    const formatAmount = (amount) => {
        return new Intl.NumberFormat('en-AE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount);
    };

    const formatAmountWithDC = (amount, dc) => {
        if (parseFloat(amount) === 0 || amount === "0.00") return '-';
        const formatted = new Intl.NumberFormat('en-AE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(Math.abs(parseFloat(amount)));

        return dc === 'D' ? `Dr ${formatted}` : `Cr ${formatted}`;
    };

    const renderAccount = (account, level = 0, parentName = '') => {
        const hasChildren = account.children && account.children.length > 0;
        const isGroup = hasChildren;
        const isExpanded = isGroupExpanded(account.id);

        // Skip rendering the "None" or null-root row itself
        const shouldSkipRow = account.name === 'None' && account.id === null;

        const openingBalance = parseFloat(account.op_total) > 0 ?
            formatAmountWithDC(account.op_total, account.op_total_dc) : '-';

        const closingBalance = parseFloat(account.cl_total) > 0 ?
            formatAmountWithDC(account.cl_total, account.cl_total_dc) : '-';

        // Render ledger row (non-group)
        if (!isGroup && !shouldSkipRow) {
            return (
                <tr key={`ledger-${account.id}`} className="ledger-row cursor-pointer" onClick={() => handleLedgerClick(account, parentName)}>
                    <td style={{ paddingLeft: `${level * 20 + 20}px` }}>
                        <span className="account-name text-primary-hover">
                            {account.name}
                        </span>
                    </td>
                    <td className="amount">{openingBalance}</td>
                    <td className="amount">
                        {parseFloat(account.dr_total) > 0 ? `Dr ${formatAmount(account.dr_total)}` : '-'}
                    </td>
                    <td className="amount">
                        {parseFloat(account.cr_total) > 0 ? `Cr ${formatAmount(account.cr_total)}` : '-'}
                    </td>
                    <td className="amount">{closingBalance}</td>
                </tr>
            );
        }

        // Render group row
        if (isGroup && !shouldSkipRow) {
            return (
                <React.Fragment key={`group-${account.id}`}>
                    <tr className="group-row">
                        <td style={{ paddingLeft: `${level * 20}px` }}>
                            <div className="group-header">
                                <span className="expand-toggle cursor-pointer" onClick={(e) => { e.stopPropagation(); toggleGroup(account.id); }}>
                                    {isExpanded ? '−' : '+'}
                                </span>
                                <span className="account-group text-primary-hover">{account.name}</span>

                            </div>
                        </td>
                        <td className="amount">{openingBalance}</td>
                        <td className="amount">
                            {parseFloat(account.dr_total) > 0 ? `Dr ${formatAmount(account.dr_total)}` : '-'}
                        </td>
                        <td className="amount">
                            {parseFloat(account.cr_total) > 0 ? `Cr ${formatAmount(account.cr_total)}` : '-'}
                        </td>
                        <td className="amount">{closingBalance}</td>
                    </tr>
                    {isExpanded && account.children && account.children.map(child =>
                        renderAccount(child, level + 1, account.name)
                    )}
                </React.Fragment>
            );
        }

        // Handle root "None" group - only render children
        if (shouldSkipRow && account.children) {
            return (
                <React.Fragment key={`root-${account.id}`}>
                    {account.children.map(child =>
                        renderAccount(child, level, account.name)
                    )}
                </React.Fragment>
            );
        }

        return null;
    };

    // useEffect(() => {


    //     fetchData();
    // }, [filters, API_BASE_URL, API_KEY, refreshTrigger]);
    useEffect(() => {
        fetchData({ start_date: null, end_date: null });
    }, []);

    const fetchData = async (customFilters = null) => {
        setLoading(true);
        setError(null);

        try {
            const params = new URLSearchParams();

            const activeFilters = customFilters ?? filters;

            if (activeFilters.start_date) params.append('start_date', activeFilters.start_date);
            if (activeFilters.end_date) params.append('end_date', activeFilters.end_date);

            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(
                `${backendUrl}/api/trial-balance`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Tenant-Origin': origin,
                        'Accept': 'application/json',
                    },
                    params,
                    skipLoader: true
                }
            );

            setData(response.data);
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to fetch trial balance data');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">Financial Reports</h4>
                            </div>
                        </div>
                    </div>

                    <div className="trial-balance-container">
                        {/* Header Section */}
                        <div className="report-header">
                            <div className="header-title">
                                <h1>Trial Balance Report</h1>
                                <p>View and analyze your account balances</p>
                            </div>
                            <div className="header-actions">
                                <button className="export-btn" onClick={() => setShowForm(true)}>
                                    ➕ Add
                                </button>
                                <button className="export-btn" onClick={expandAllGroups}>
                                    Expand All
                                </button>
                                <button className="export-btn" onClick={collapseAllGroups}>
                                    Collapse All
                                </button>
                                {/* Debug button - uncomment to check state */}
                                {/* <button className="export-btn" onClick={debugState} style={{backgroundColor: '#f8f9fa'}}>
                                    Debug
                                </button> */}
                                {/* <button
                                    onClick={() => handleExport('csv')}
                                    className="export-btn"
                                    disabled={loading || !data}
                                >
                                    <span className="icon">📊</span> CSV
                                </button>
                                <button
                                    onClick={() => handleExport('xls')}
                                    className="export-btn"
                                    disabled={loading || !data}
                                >
                                    <span className="icon">📈</span> Excel
                                </button> */}
                            </div>
                        </div>

                        {/* Filter Section */}
                        <div className="filter-section">
                            <h2>Filters</h2>
                            <form onSubmit={handleSubmit}>
                                <div className="row g-3 align-items-end mb-3">
                                    <div className="col-md-3">
                                        <label className="form-label font-size-12 fw-bold text-muted mb-1">Date Range Type</label>
                                        <select
                                            className="form-select form-select-sm"
                                            value={dateRangeType || 'custom'}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setDateRangeType(value);
                                                if (value === 'yearly') {
                                                    setFilters({ start_date: null, end_date: null });
                                                }
                                            }}
                                        >
                                            <option value="yearly">Yearly</option>
                                            <option value="custom">Custom Range</option>
                                        </select>
                                    </div>

                                    {dateRangeType === 'yearly' ? (
                                        <>
                                            <div className="col-md-3">
                                                <label className="form-label font-size-12 fw-bold text-muted mb-1">Start Date</label>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        views={["year", "month", "day"]}
                                                        openTo="year"
                                                        format="DD-MM-YYYY"
                                                        value={filters.start_date ? dayjs(filters.start_date) : null}
                                                        onChange={(newValue) => {
                                                            if (newValue) {
                                                                if (!filters.start_date || dayjs(filters.start_date).year() !== newValue.year()) {
                                                                    const start = newValue.startOf('year');
                                                                    const end = newValue.endOf('year');
                                                                    setFilters({
                                                                        ...filters,
                                                                        start_date: start.format('YYYY-MM-DD'),
                                                                        end_date: end.format('YYYY-MM-DD')
                                                                    });
                                                                } else {
                                                                    setFilters({
                                                                        ...filters,
                                                                        start_date: newValue.format('YYYY-MM-DD')
                                                                    });
                                                                }
                                                            }
                                                        }}
                                                        slotProps={{
                                                            textField: { size: "small", fullWidth: true }
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </div>
                                            <div className="col-md-3">
                                                <label className="form-label font-size-12 fw-bold text-muted mb-1">End Date</label>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        views={["year", "month", "day"]}
                                                        openTo="year"
                                                        format="DD-MM-YYYY"
                                                        value={filters.end_date ? dayjs(filters.end_date) : null}
                                                        onChange={(newValue) => {
                                                            if (newValue) {
                                                                if (!filters.end_date || dayjs(filters.end_date).year() !== newValue.year()) {
                                                                    setFilters({
                                                                        ...filters,
                                                                        end_date: newValue.endOf('year').format('YYYY-MM-DD')
                                                                    });
                                                                } else {
                                                                    setFilters({
                                                                        ...filters,
                                                                        end_date: newValue.format('YYYY-MM-DD')
                                                                    });
                                                                }
                                                            }
                                                        }}
                                                        slotProps={{
                                                            textField: { size: "small", fullWidth: true }
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div className="col-md-3">
                                                <label className="form-label font-size-12 fw-bold text-muted mb-1" htmlFor="start_date">From Date</label>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        views={["year", "month", "day"]}
                                                        density="compact"
                                                        format="DD-MM-YYYY"
                                                        value={
                                                            filters.start_date && dayjs(filters.start_date).isValid()
                                                                ? dayjs(filters.start_date)
                                                                : null
                                                        }
                                                        onChange={(newValue) => {
                                                            setFilters(prev => {
                                                                const { startDate: newStart, suggestedEndDate } = getAdjustedStartDate(newValue, prev.end_date);
                                                                const newFilters = { ...prev, start_date: newStart };
                                                                if (suggestedEndDate) {
                                                                    newFilters.end_date = suggestedEndDate;
                                                                }
                                                                return newFilters;
                                                            });
                                                        }}
                                                        slotProps={{
                                                            textField: {
                                                                size: "small",
                                                                fullWidth: true,
                                                            },
                                                            popper: {
                                                                sx: {
                                                                    "& .MuiPaper-root": {
                                                                        fontSize: "0.7rem",
                                                                        minWidth: 260,
                                                                    },
                                                                },
                                                            },
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </div>

                                            <div className="col-md-3">
                                                <label className="form-label font-size-12 fw-bold text-muted mb-1" htmlFor="end_date">To Date</label>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        views={["year", "month", "day"]}
                                                        format="DD-MM-YYYY"
                                                        value={
                                                            filters.end_date && dayjs(filters.end_date).isValid()
                                                                ? dayjs(filters.end_date)
                                                                : null
                                                        } onChange={(newValue) => {
                                                            setFilters(prev => {
                                                                return { ...prev, end_date: getAdjustedEndDate(newValue, prev.start_date) };
                                                            });
                                                        }}
                                                        density="compact"
                                                        slotProps={{
                                                            textField: {
                                                                size: "small",
                                                                fullWidth: true,
                                                                sx: {
                                                                    "& input": {
                                                                        fontSize: "0.65rem",
                                                                        padding: "4px 6px",
                                                                    },
                                                                },
                                                            },
                                                            popper: {
                                                                sx: {
                                                                    "& .MuiPaper-root": {
                                                                        fontSize: "0.65rem",
                                                                        minWidth: 100,
                                                                    },
                                                                },
                                                            },
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </div>
                                        </>
                                    )}

                                    <div className="col-md-3 d-flex gap-2">
                                        <button
                                            type="submit"
                                            className="btn btn-primary btn-sm px-4"
                                            disabled={loading}
                                        >
                                            {loading ? 'Processing...' : 'Apply Filters'}
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-outline-secondary btn-sm px-4"
                                            onClick={handleClear}
                                            disabled={loading}
                                        >
                                            Clear
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>

                        {/* Error Message */}
                        {error && (
                            <div className="error-message">
                                <span className="error-icon">⚠️</span>
                                <span>{error}</span>
                                <button onClick={() => setError(null)} className="error-close">
                                    ×
                                </button>
                            </div>
                        )}

                        {/* Loading State */}
                        {loading && !data && (
                            <div className="loading-state">
                                <div className="spinner"></div>
                                <p>Loading trial balance data...</p>
                            </div>
                        )}

                        {/* Data Display */}
                        {!loading && data && (
                            <div className="report-content">
                                <div className="report-info">
                                    <h3>
                                        {filters.start_date || filters.end_date
                                            ? `Period: ${filters.start_date ? format(new Date(filters.start_date), 'dd MMM yyyy') : 'Beginning'} to ${filters.end_date ? format(new Date(filters.end_date), 'dd MMM yyyy') : 'Now'}`
                                            : 'All Accounts'}
                                    </h3>
                                    <span className="generated-on">
                                        Generated on: {format(new Date(), 'dd MMM yyyy, hh:mm a')}
                                    </span>
                                </div>

                                <div className="table-container">
                                    <table className="trial-balance-table">
                                        <thead>
                                            <tr>
                                                <th>Account Name</th>
                                                <th>Opening Balance</th>
                                                <th>Debit Total</th>
                                                <th>Credit Total</th>
                                                <th>Closing Balance</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {data.accountlist?.map(account => renderAccount(account))}

                                            {data.totals && (
                                                <tr className="total-row">
                                                    <td><strong>Total</strong></td>
                                                    <td className="amount"><strong>-</strong></td>
                                                    <td className="amount"><strong>Dr {formatAmount(data.totals.debit_total)}</strong></td>
                                                    <td className="amount"><strong>Cr {formatAmount(data.totals.credit_total)}</strong></td>
                                                    <td className="amount"><strong>-</strong></td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                {data.totals?.balanced !== undefined && (
                                    <div className={`balance-status ${data.totals.balanced ? 'balanced' : 'unbalanced'}`}>
                                        {data.totals.balanced ? '✓' : '⚠'}
                                        <strong>
                                            {data.totals.balanced
                                                ? 'Trial Balance is balanced'
                                                : 'Trial Balance is not balanced'}
                                        </strong>
                                    </div>
                                )}
                            </div>
                        )}

                        <AccountUploadForm
                            show={showForm}
                            onClose={() => setShowForm(false)}
                            onSuccess={() => {
                                setShowForm(false);
                                setRefreshTrigger(prev => prev + 1);
                            }}
                        />

                        <LedgerDetailsOffcanvas
                            show={showOffcanvas}
                            onHide={() => setShowOffcanvas(false)}
                            ledger={selectedLedger}
                            startDate={filters.start_date}
                            endDate={filters.end_date}
                            projectId={null}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TrialBalance;
